import * as React from "react";
import { forwardRef } from "react";
const SvgUnassign = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 31, height: 31, rx: 15.5, stroke: "#E7343F" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.59961 15.2H22.3996V16.8H9.59961V15.2Z", fill: "#E7343F" }));
const ForwardRef = forwardRef(SvgUnassign);
export default ForwardRef;
